import { FC } from 'react';
import { useUser } from './hooks/user';
import { Button } from '../../components/button/Button';
import { useNavigate } from 'react-router-dom';
import { Card } from '@softwareimaging/react';
import { FiAlertTriangle } from 'react-icons/fi';

export const NotVerified: FC = () => {
  const user = useUser();
  const navigate = useNavigate();

  return (
    <div className="h-screen w-screen flex items-center justify-center">
      <Card className={'flex flex-col items-center gap-5 text-primary-800 max-w-2xl p-10'}>
        <FiAlertTriangle className="h-16 w-16" />
        <div className="space-y-2">
          <div>{`The login was successful, but ${user.email} is not a verified user. Please ask an administrator to add this email to the list of users.`}</div>
          <div>{`If this is not the correct email, please sign out and sign in with the correct one.`}</div>
        </div>
        <Button onClick={() => navigate('/auth/signout')} primary>
          Sign Out
        </Button>
      </Card>
    </div>
  );
};
